'use strict';

// 登录逻辑处理
import t from '@/utils/type.js'
import {
  Method_EasySelect,
  Method_EasyAdd,
  Method_EasyDelete,
  Method_EasyUpdate,
  Method_DataByPage,
  Method_Contract,
  Method_ContractPass
} from '@/utils/loadhttpdata.js';

import api from '@/utils/http.js'

// 获取指定订单的操作权限
export function api_control(menuvalue) {
  return new Promise((resolve, reject) => {
    // console.log(menuvalue);
    api.post(
      t.http_method,
      Method_EasySelect('data_menu_btnrole', menuvalue)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);

      resolve(res.data)
    });
  })
}

// 通用简单操作
export function api_EasySelect(action, data1, data2) {
  return new Promise((resolve, reject) => {

    api.post(
      t.http_method,
      Method_EasySelect(action, data1, data2)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);

      resolve(res.data)
    });
  })
}
export function api_EasyAdd(action, data1, data2, data3, data4, data5) {
  return new Promise((resolve, reject) => {

    api.post(
      t.http_method,
      Method_EasyAdd(action, data1, data2, data3, data4, data5)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);

      resolve(res.data)
    });
  })
}

export function api_EasyDelete(action, rowid) {
  return new Promise((resolve, reject) => {

    api.post(
      t.http_method,
      Method_EasyDelete(action, rowid)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);

      resolve(res.data)
    });
  })
}

export function api_EasyUpdate(action, id, data1, data2, data3, data4, sys_date) {
  return new Promise((resolve, reject) => {
    api.post(
      t.http_method,
      Method_EasyUpdate(action, id, data1, data2, data3, data4, sys_date)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);

      resolve(res.data)
    });
  })
}

export function api_DataByPage(action, data1, data2, data3) {
  return new Promise((resolve, reject) => {
    api.post(
      t.http_method,
      Method_DataByPage(action, data1, data2, data3)
    ).then(res => {
      res = JSON.parse(res);
      // console.log(res.data);
      resolve(res.data)
    });
  })
}

